import { lazy } from "react";

const MembershipPage = lazy(() => import("./main"));

export { MembershipPage };
